import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useIsMobile } from './hooks/useIsMobile';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ContactsPage from './pages/ContactsPage';
import ContratsPage from './pages/ContratsPage';
import DevisPage from './pages/DevisPage';
import FacturesPage from './pages/FacturesPage';
import OpportunitesPage from './pages/OpportunitesPage';
import AuditPage from './pages/AuditPage';
import MissionsPage from './pages/MissionsPage';
import ConformitePage from './pages/ConformitePage';
import ImportPage from './pages/ImportPage';
import ComptaPage from './pages/ComptaPage';
import AgendaPage from './pages/AgendaPage';
import AdminPage from './pages/AdminPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Sidebar from './components/Sidebar';
import logoWhite from './assets/logo-white.svg';
import './App.css';


function AppRoutes({ onNavigate }) {
  const location = useLocation();
  useEffect(() => { onNavigate(); }, [location.pathname]);
  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/agenda" element={<AgendaPage />} />
      <Route path="/clients" element={<ClientsPage />} />
      <Route path="/contacts" element={<ContactsPage />} />
      <Route path="/contrats" element={<ContratsPage />} />
      <Route path="/devis" element={<DevisPage />} />
      <Route path="/factures" element={<FacturesPage />} />
      <Route path="/opportunites" element={<OpportunitesPage />} />
      <Route path="/audits" element={<AuditPage />} />
      <Route path="/missions" element={<MissionsPage />} />
      <Route path="/conformite" element={<ConformitePage />} />
      <Route path="/import" element={<ImportPage />} />
      <Route path="/comptabilite" element={<ComptaPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) { return null; }

  return (
    <Router future={{ v7_relativeSplatPath: true }}>
      {isAuthenticated ? (
        <div style={{ display: 'flex', height: '100vh' }}>
          {/* Backdrop mobile */}
          {isMobile && sidebarOpen && (
            <div
              onClick={() => setSidebarOpen(false)}
              style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 199 }}
            />
          )}

          <Sidebar isMobile={isMobile} mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

          <div style={{ flex: 1, overflowY: 'auto', minWidth: 0 }}>
            {/* Barre top mobile */}
            {isMobile && (
              <div style={{
                position: 'sticky', top: 0, zIndex: 100,
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 16px',
                background: '#12141f', borderBottom: '1px solid #2a2d3e',
              }}>
                <button
                  onClick={() => setSidebarOpen(true)}
                  style={{
                    background: 'transparent', border: 'none', color: '#e2e8f0',
                    cursor: 'pointer', fontSize: 22, padding: '0 4px', lineHeight: 1,
                  }}
                >
                  ☰
                </button>
                <img src={logoWhite} alt="LA DONNÉE" style={{ height: 22, objectFit: 'contain' }} />
              </div>
            )}

            <AppRoutes onNavigate={() => setSidebarOpen(false)} />
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
